import { render, staticRenderFns } from "./my-workspaces-view.vue?vue&type=template&id=388db6ac"
import script from "./my-workspaces-view.vue?vue&type=script&lang=js"
export * from "./my-workspaces-view.vue?vue&type=script&lang=js"
import style0 from "./my-workspaces-view.vue?vue&type=style&index=0&id=388db6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports